import React, { Component, Fragment } from 'react';
import get from 'lodash.get'
import { SUBJECT_COUNT } from '../constants'
import {setDocTitle} from '../../utils/tools'
import { getSubjects, postSubjects,getRecommendSubject } from '../../api/subjectChoice'
import Submitted from './Submitted'
import Confirm from './Confirm'
import './Subjects.less'
import  checkedWhite from '../../assets/svg/checked-white.png';
import  checkedBlue from '../../assets/svg/checked-blue.png';
const STATES = {
  CHOOSING: 'CHOOSING',
  ON_CONFIRM: 'ON_CONFIRM',
  SUCCEED: 'SUCCEED',
};

class Subjects extends Component {
  user_detail=JSON.parse(localStorage.getItem('user_detail'));
  constructor(props) {
    super(props);
    this.state = {
      subjectGroups: [],
      selected: new Map(),
      state: STATES.CHOOSING,
      recSubject:[],
      recCombinations:[],
      selectedCombinations:new Map(),
    }
  }

  componentDidMount() {
      const host = window.location.host;
      if(host==='xs.shijieu.cn'){
          setDocTitle('试界云学生端');
      }
      else if(host==='xs.t.shijieu.cn'){
          setDocTitle('试界云学生端-测试版');
      }
      else {
          setDocTitle('试界云测试端');
      }
    const { match, history } = this.props;
    const province = get(match, 'params.province');
    if (!province) {
      history.push('./welcome');
    } else {
      getSubjects(province).then(({ data }) => {
        this.setState({
          subjectGroups: data,
        });
      });
      getRecommendSubject().then(({ data }) => {
          if(data){
              this.setState({
                  recSubject: data.subjects,
                  recCombinations: data.combinations,
              });
          }
      })
    }
  }

  isSelfProvince(){
    const { match } = this.props;
    const province = get(match, 'params.province');
    return province==this.user_detail.student.school.provinceId;
  }
  isRecommendSubject(id){
    let {recSubject}=this.state;
    return recSubject.filter(r => r.id == id)[0];
  }
  handleSubjectClick(subject) {
    const { selected, subjectGroups ,recCombinations} = this.state;
    let newMap = new Map(selected);
    let newCombinationsMap = new Map();
    if (selected.has(subject.id)) {
      newMap.delete(subject.id)
    } else {
      // 检查每个组是否超过限定的选择数
      for (let i = 0; i < subjectGroups.length; i++) {
        const group = subjectGroups[i];
        if (group.subjects.find(d => d.id === subject.id)) {
          const choice = group.choice;
          const seletedCount = group.subjects.reduce((sum, d) => (selected.has(d.id) ? 1 : 0) + sum, 0);
          if (seletedCount < choice) {
            newMap.set(subject.id, subject);
          }
        }
      }
    }
    recCombinations.forEach(r=>{
      if(Array.from(newMap.keys()).sort().toString()==r.subjects.sort().toString()){
          newCombinationsMap.set(r.subjects, r);
      }
    });
    this.setState({
        selected: newMap,
        selectedCombinations: newCombinationsMap,
    });
  }

  handleCombinationsClick(combinations){
      const { selectedCombinations ,subjectGroups} = this.state;
      let newMap = new Map(selectedCombinations);
      let newSelectedMap = new Map();
      let subjectList=[];
      if (selectedCombinations.has(combinations.subjects)) {
          newMap.delete(combinations.subjects);
      } else {
          newMap.clear();//清除已选
          newMap.set(combinations.subjects, combinations);
          subjectGroups.forEach(s=>{
              subjectList=subjectList.concat(s.subjects);
          });//组合所有科目
          combinations.subjects.forEach(i=>{
              newSelectedMap.set(i, subjectList.filter(s=>s.id==i)[0]);
          });
      }
      this.setState({
          selectedCombinations: newMap,
          selected:newSelectedMap,
      });
  }

  handleGotoConfirm() {
    this.setState({
      state: STATES.ON_CONFIRM
    });
  }

  handleBackToModify() {
    this.setState({
      state: STATES.CHOOSING
    });
  }

  handlePostSubject() {
    const { selected } = this.state;
    let subjects = Array.from(selected.values());
    subjects.forEach(i=>{
      if(i.id==25)i.sort=-2;
      if(i.id==26)i.sort=1;
      if(i.id==27)i.sort=2;
      if(i.id==28)i.sort=3;
      if(i.id==29)i.sort=-1;
      if(i.id==30)i.sort=4;
      if(i.id==31)i.sort=5;
    });
    subjects.sort((a,b)=>{return a.sort-b.sort});
    // let query = subjects.map((d, i) => `subject${i + 1}=${d.id}`).join('&');
    let param={};
    subjects.map((i,index) => {
        param[`subject${index+1}`]=i.id
    });
    postSubjects(param).then(() => {
      this.setState({
        state: STATES.SUCCEED,
      });
    })
  }

  render() {
    const { subjectGroups, selected, state,recSubject, recCombinations,selectedCombinations } = this.state;

    switch (state) {
      case STATES.ON_CONFIRM:
        return <Confirm subjects={Array.from(selected.values())}
          onConfirm={this.handlePostSubject.bind(this)}
          onBackToModify={this.handleBackToModify.bind(this)}
        />;
      case STATES.SUCCEED:
        return <Submitted />;
      default:
        return (
          <div className="subject-choice-wrapper">
            <div className="subject-choice-inner">
              <h1>填写你的选科意向</h1>
              {
                  (recCombinations.length>0 || recSubject.length>0) && this.isSelfProvince() &&
                  <p className='recommend-title'>学校为你推荐了一些科目组合或科目，选择这些<span className='bold-remind'>推荐组合/科目</span>可能会更好地发挥学校优势。</p>
              }
              {recCombinations.length>0 && this.isSelfProvince() &&
                <div className="recommend-group">
                    <p className="sub-title">快速选择推荐组合</p>
                    <div className="subject-list">
                        {recCombinations.map((d,index) => (
                            <div key={index} className={`subject ${selectedCombinations.has(d.subjects) ? 'selected' : ''}`} onClick={this.handleCombinationsClick.bind(this, d)}>
                                {selectedCombinations.has(d.subjects) && <img src={checkedBlue} alt=""/>}
                                {d.name}
                            </div>
                        ))}
                    </div>
                </div>
              }
              {subjectGroups.map((group, i) => (
                <Fragment key={i}>
                  <p className="sub-title">请选择{group.choice}个科目</p>
                  <div className="subject-list">
                    {group.subjects.map(d => (
                      <div key={d.id} className={`subject ${selected.has(d.id) ? 'selected' : ''}`} onClick={this.handleSubjectClick.bind(this, d)}>
                          {selected.has(d.id) && <img src={checkedWhite} alt=""/>}
                          {d.name}
                          {this.isRecommendSubject(d.id) && this.isSelfProvince() && <div className='recommend-sign'></div>}
                      </div>
                    ))}
                  </div>
                </Fragment>
              ))}
            </div>
            <div className="subject-choice-bottom">
              <button className="primary full" disabled={selected.size < SUBJECT_COUNT} onClick={this.handleGotoConfirm.bind(this)}>
                {selected.size < SUBJECT_COUNT
                  ? `请选择${SUBJECT_COUNT}个科目(${selected.size}/${SUBJECT_COUNT})`
                  : '确认选择'
                }
              </button>
            </div>
          </div>
        )
    }
  }
}

export default Subjects;



// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/Subjects.js